import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var CrmCurrencyTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CrmCurrencyTransformer, _BaseTransformer);
  var _super = _createSuper(CrmCurrencyTransformer);
  function CrmCurrencyTransformer() {
    _classCallCheck(this, CrmCurrencyTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CrmCurrencyTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        recordId: data.record_id,
        currencyName: data.currency_name
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return CrmCurrencyTransformer;
}(BaseTransformer);